import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { OrderIdAccessor } from 'app/00_modules/core/services/accessors/order-id.accessor';
import { BehaviorSubject } from 'rxjs';
import { NotificationService as ClientNotificationService } from '../../../core/services/notification.service';
import { ErrorInformationFromUser } from '../../models/ErrorInformationFromUser';
import { SubmitErrorServices } from '../../services/submitError.service';
import { Screenshot } from '../../models/Screenshot';
import { FormsModule } from '@angular/forms';
import { BsmTextarea } from '@bsm-ui-lib/bsm-ui';
import { AsyncPipe, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../../../shared/components/fa-icon/fa-icon.component';
import { MessageBoxComponent } from '../../../shared/components/message-box/message-box.component';

import { ButtonComponent } from '../../../shared/components/buttons/button/button.component';

import { DialogRef } from '../../../shared/components/dialog/dialog-ref';
import { DialogWrapperComponent, JeDialogTitleDirective, JeDialogFooterDirective } from '../../../shared/components/dialog/dialog-wrapper.component';
@Component({
    selector: 'je-submitError',
    templateUrl: './submitError.component.html',
    imports: [
        ButtonComponent,
        FormsModule,
        BsmTextarea,
        NgClass,
        TranslateModule,
        AsyncPipe,
        IconComponent,
        MessageBoxComponent,
        DialogWrapperComponent,
        JeDialogTitleDirective,
        JeDialogFooterDirective,
    ],
})
export class SubmitErrorComponent {
    public errorText: string;
    public errorInfo = new ErrorInformationFromUser();
    public isProcessing$ = new BehaviorSubject<boolean>(false);
    public file: File;
    public errorMessage: string = null;

    @ViewChild('fileInput') fileInput!: ElementRef;

    constructor(
        private matDialog: DialogRef,
        private submitErrorService: SubmitErrorServices,
        private router: Router,
        private orderIdAccessor: OrderIdAccessor,
        private clientNotificationService: ClientNotificationService,
    ) {}

    public screenshotUploaded(event: any): void {
        this.errorMessage = null;
        this.file = event.target.files[0];
        if (this.file) {
            if (!this.isValidFileType(this.file)) {
                this.errorMessage = 'ERROR_SUBMIT.FILE_TYPE_NOT_SUPPORTED';
                this.resetFileInput();
                return;
            }

            if (this.file.size > 10 * 1024 * 1024) {
                this.errorMessage = 'ERROR_SUBMIT.FILE_TOO_LARGE';
                this.resetFileInput();
                return;
            }

            this.errorInfo.Screenshot = new Screenshot();

            this.errorInfo.Screenshot.FileName = this.file.name;

            this.getFileAsByteArray(this.file).then(byteArray => {
                this.errorInfo.Screenshot.File = Array.from(byteArray);
            });
        }
    }

    isValidFileType(file: File): boolean {
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'application/pdf'];
        return validTypes.includes(file.type);
    }

    resetFileInput(): void {
        if (this.fileInput) {
            this.fileInput.nativeElement.value = '';
            this.file = null;
        }
    }

    public getFileAsByteArray(file: File): Promise<Uint8Array> {
        return new Promise<Uint8Array>((resolve, reject) => {
            if (!file) {
                reject('Keine Datei gefunden');
                return;
            }
            const reader = new FileReader();

            reader.onload = () => {
                const arrayBuffer = reader.result as ArrayBuffer;
                const byteArray = new Uint8Array(arrayBuffer);
                resolve(byteArray);
            };

            reader.onerror = () => {
                reject('Fehler beim Lesen der Datei');
            };

            reader.readAsArrayBuffer(file);
        });
    }

    public async onSubmitButtonClick(): Promise<void> {
        let orderId: number;
        try {
            orderId = this.orderIdAccessor.orderId;
        } catch (e) {}
        this.isProcessing$.next(true);
        const route = this.router.url;
        this.errorInfo.ErrorText = this.errorText;
        this.errorInfo.OrderId = orderId;
        this.errorInfo.OriginUrl = window.location.href;
        this.errorInfo.Route = route;
        this.errorInfo.WindowHeight = window.innerHeight;
        this.errorInfo.WindowWidth = window.innerWidth;
        this.submitErrorService
            .submitError(this.errorInfo)
            .then(async () => {
                await this.clientNotificationService.infoTranslate('ERROR_SUBMIT.SENDSUCCESS');
                this.matDialog.close();
                this.isProcessing$.next(false);
            })
            .catch(async () => {
                await this.clientNotificationService.infoTranslate('ERROR_SUBMIT.SENDERROR');
                this.matDialog.close();
                this.isProcessing$.next(false);
            });
    }

    public onBackButtonClick(): void {
        this.errorInfo = null;
        this.matDialog.close();
    }
}
